<div class="main-bg">
  <nav class="main-nav">
    <div class="nav-left">
      <div class="custom-lang-select">
        <div class="lang-button" (click)="toggleLangDropdown()">
          <span *ngIf="selectedLang === 'en'">English</span>
          <span *ngIf="selectedLang === 'ar'">العربية</span>
          <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>
        </div>
      </div>
    </div>
    <div class="nav-right">
      <!-- Removed site name from header -->
    </div>
  </nav>
  
  <!-- Site name banner - keeping only this as the main location display -->
  <div class="site-banner">
    <div class="site-badge">
      <mat-icon>location_on</mat-icon>
      <span>{{ siteName }}</span>
    </div>
  </div>
  
  <!-- Move dropdown outside of nav to prevent overflow issues -->
  <div class="dropdown-container" *ngIf="showLangDropdown" [ngStyle]="dropdownPosition">
    <div class="lang-dropdown">
      <div class="lang-option" (click)="changeLang('en')" *ngIf="selectedLang !== 'en'">English</div>
      <div class="lang-option" (click)="changeLang('ar')" *ngIf="selectedLang !== 'ar'">العربية</div>
    </div>
  </div>
  
  <div class="form-container kiosk-mode">
    <img src="assets/img/logo.png" alt="Logo" class="form-logo" />
    
    <!-- Step 1: Form with site name display removed -->
    <div *ngIf="step == 1" class="kiosk-form">
      <div class="form-title">{{ t('carInfoTitle') }}</div>
      <!-- Removed site name subtitle -->
      <form class="f-form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline" class="full-width kiosk-field">
          <mat-label>{{ t('selectState') }}</mat-label>
          <mat-select placeholder="{{ t('selectStatePlaceholder') }}" formControlName="state" (selectionChange)="selectState()" class="kiosk-select">
            <mat-option *ngFor="let state of States" [value]="state.stateName">
              {{ state.stateName }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="!form.controls['state'].valid && form.controls['state'].touched">
            {{ t('stateRequired') }}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width kiosk-field" appearance="outline">
          <mat-label>{{ t('plateText') }}</mat-label>
          <input matInput maxlength="7" minlength="1" placeholder="{{ t('plateTextPlaceholder') }}" formControlName="plate" class="uppercase-input kiosk-input" />
          </mat-form-field>
        <mat-error class="full-width" style="margin: 0px 0px 20px 0px;" *ngIf="!form.controls['plate'].valid && form.controls['plate'].touched">
          {{ t('plateRequired') }}
        </mat-error>
        <button mat-raised-button color="primary" [disabled]="!(form.valid)" class="kiosk-button">
          {{ t('confirm') }}
        </button>
      </form>
      <div class="form-description">
        {{ t('formDesc') }}
      </div>
    </div>
    
    <!-- Step 5: Bills Table and Payment Methods -->
    <div *ngIf="step == 5" class="bills-container payment-step">
      <!-- Removed site name from payment step header -->
      
      <!-- Show bill summary and plate information first -->
      <div *ngIf="processedBillsData && processedBillsData.length > 0" class="plate-info kiosk-text">
        <div class="plate-number">
          <span class="label">{{ t('plate') }}:</span>
          <span class="value">{{ form.value.plate }}</span>
        </div>
        <div class="plate-state">
          <span class="label">{{ t('state') }}:</span>
          <span class="value">{{ form.value.state }}</span>
        </div>
      </div>
      
      <!-- Loading indicator for payment methods -->
      <div *ngIf="isLoadingPaymentMethods" class="loading-container">
        <img src="assets/img/hourglass_empty.png" alt="Loading" class="loading-icon">
        <p class="loading-text">{{ t('processing') }}</p>
      </div>
      
      <!-- Payment Methods Section - Show at the top -->
      <div *ngIf="!isLoadingPaymentMethods && provider.toLowerCase() === 'myfatoorah' && paymentMethods && paymentMethods.length > 0" class="payment-methods-section kiosk-payment">
        <h3>{{ t('paymentMethods') }}</h3>
        <p class="select-instruction">{{ t('selectPaymentMethod') }}</p>
        
        <div class="payment-methods-grid compact-grid">
          <div 
            *ngFor="let method of paymentMethods" 
            class="payment-method-card compact-card" 
            [class.selected]="selectedPaymentMethod?.PaymentMethodId === method.PaymentMethodId"
            [class.disabled]="isProcessingPayment"
            (click)="!isProcessingPayment && executePayment(method)">
            
            <div class="payment-method-logo">
              <img [src]="method.ImageUrl" [alt]="method.PaymentMethodEn">
            </div>
            
            <div class="payment-method-info">
              <h4>{{ selectedLang === 'ar' ? method.PaymentMethodAr : method.PaymentMethodEn }}</h4>
              <p class="payment-amount">
                {{ method.TotalAmount }} {{ method.CurrencyIso }}
                <span *ngIf="method.ServiceCharge > 0" class="service-charge">
                  ({{ t('includes') }} {{ method.ServiceCharge }} {{ method.CurrencyIso }} {{ t('serviceCharge') }})
                </span>
              </p>
            </div>
          </div>
        </div>
        
        <!-- Payment processing indicator -->
        <div *ngIf="isProcessingPayment" class="processing-container">
          <img src="assets/img/hourglass_empty.png" alt="Processing" class="loading-icon">
          <p class="loading-text">{{ t('processing') }}</p>
        </div>
      </div>
      
      <!-- Only show the header when we have bills - moved below payment -->
      <div *ngIf="processedBillsData && processedBillsData.length > 0" class="bills-header kiosk-text">
        <h2>{{ t('openBills') }}</h2>
      </div>
      
      <!-- Show table if we have processed bills data -->
      <div *ngIf="billsData && billsData.length > 0">
        <div class="bills-table-wrapper kiosk-table">
          <table class="bills-table">
            <thead>
              <tr>
                <th>{{ t('plate') }}</th>
                <th>{{ t('state') }}</th>
                <th>{{ t('site') }}</th>
                <th>{{ t('entryTime') }}</th>
                <th>{{ t('exitTime') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let bill of billsData">
                <td>{{ bill.plateNumber }}</td>
                <td>{{ bill.state }}</td>
                <td>{{ bill.site }}</td>
                <td>{{ bill.entryTime }}</td>
                <td>{{ bill.exitTime }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      <!-- Show message if bills array is empty -->
      <div *ngIf="!processedBillsData || processedBillsData.length === 0" class="empty-bills-message kiosk-message">
        <div class="success-message-container">
          <div class="success-icon">
            <mat-icon>check_circle</mat-icon>
          </div>
          <h3 class="success-title">{{ t('noBillsMessage') }}</h3>
          <div class="message-footer">
            <img src="assets/img/logo.png" alt="Limitless Parking" class="message-logo">
            <button mat-raised-button color="primary" (click)="backTo1()" class="back-button kiosk-button">
              {{ t('backToSearch') }}
            </button>
          </div>
        </div>
      </div>
      
      <button *ngIf="processedBillsData && processedBillsData.length > 0" mat-raised-button color="primary" (click)="backTo1()" class="back-button kiosk-button">
        {{ t('backToSearch') }}
      </button>
    </div>
    
    <!-- Other existing steps -->
    <div class="pay scrollable-step" *ngIf="showPayButton && step == 2">
      <h1>{{ t('amount') }} :<span style="color: #4e0080;">{{ amount | number: '.2-2' }} </span>AED</h1>
    </div>
    <div class="succcess scrollable-step" *ngIf="step == 3">
      <div class="thanks">
        <h2>{{ t('paymentSuccess') }}</h2>
      </div>
    </div>
    <div class="succcess scrollable-step" *ngIf="step == 4">
      <div class="thanks">
        <h2>{{ t('billZero') }}</h2>
      </div>
    </div>
  </div> 
</div>

<!-- Environment toggle button - fixed to the bottom corner -->
 <!--
<div class="env-toggle">
  <button 
    (click)="toggleEnvironment()" 
    class="env-toggle-button"
    [attr.title]="'Click to toggle between DEV and PROD environments'">
    ENV: {{ currentEnvironment }}
  </button>
</div>
-->
<!-- Add this CSS to the component -->
<!--style>
  .env-toggle {
    position: fixed;
    bottom: 10px;
    right: 10px;
    z-index: 9999;
  }
  
  .env-toggle-button {
    background-color: #333;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 12px;
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.3s;
  }
  
  .env-toggle-button:hover {
    opacity: 1;
  }
</style-->
